module.exports = __webpack_public_path__ + "img/cancel_2.332ed636.svg";